import React from "react";
import { IconT } from "types/utils";

const Ellipses = ({ fill = "var(--silver-grey)", height = "4", width = "14" }: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="19" cy="3" r="3" fill={fill} />
      <circle cx="11" cy="3" r="3" fill={fill} />
      <circle cx="3" cy="3" r="3" fill={fill} />
    </svg>
  );
};

export default Ellipses;
